module.exports = __webpack_public_path__ + "img/timeline-img-2.cc80defa.png";